import React from "react";
import makeStyles from "@material-ui/core/styles/makeStyles";
import Support from "./Support";
import companyInfo from "../../themes/themes";

const useStyles = makeStyles((theme) => ({
  footer: { textAlign: "center", paddingBottom: 20 },
}));

export default function FooterContent() {
  const classes = useStyles();
  const theme = process.env.REACT_APP_THEME;
  const width =
    window.location.pathname === "/signup" ||
    window.location.pathname === "/login"
      ? "50%"
      : "100%";
  return (
    <div className={classes.footer} style={{ width }}>
      {companyInfo[theme].displaySupportFooter && <Support />}
    </div>
  );
}
